import ApplicationController from "application_controller.js";

export default class extends ApplicationController  {
  debug = false;

  static targets = ["printedAt"];

  static values = {
    pageName: { type: String, default: "" },
  };

  connect() {
    this.log_function("connect");

    this.bound_before_print = this.before_print.bind(this);
    this.bound_after_print = this.after_print.bind(this);
    window.addEventListener("beforeprint", this.bound_before_print);
    window.addEventListener("afterprint", this.bound_after_print);
  }

  before_print(event) {
    this.log_function("before_print", event);

    // The page may be served from cache, so stamp the real print time here
    // rather than trusting the server-rendered timestamp.
    if (this.hasPrintedAtTarget) {
      this.printedAtTarget.textContent = this.formatted_now();
    }
  }

  after_print(event) {
    this.log_function("after_print", event);

    this.dispatch("ahoy_trackEvent", { detail: { type: "ux", action: "printed page", page: this.pageNameValue }, prefix: false });
  }

  formatted_now() {
    const now = new Date();
    const pad = (value) => String(value).padStart(2, "0");

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear();
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  disconnect(){
    this.log_function("disconnect");

    window.removeEventListener("beforeprint", this.bound_before_print);
    window.removeEventListener("afterprint", this.bound_after_print);
  }
}
